import { boolify as a } from "../value/bool.js";
const o = (e) => a(e, (e == null ? void 0 : e.value) ?? e);
export {
  o as parseBooleanProp
};
